import MenuItem from "../models/menu-item.model";

export const accountMenuMock: any[] = [{
    menuKey: 1,
    id: '1',
    label: "Manage your Account",
    desc: "you can change your personal information",
    url: ""
}, {
    menuKey: 2,
    id: '2',
    label: "Personal Information",
    desc: "you can change your personal information",
    url: ""
}, {
    menuKey: 3,
    id: '3',
    label: "Contact Details",
    desc: "you can change your personal information",
    url: "",
}, {
    menuKey: 4,
    id: '4',
    label: "Access Other IT Systems",
    desc: "you can change your personal information",
    url: ""
}, {
    menuKey: 5,
    id: '5',
    label: "Organisation and Role Management",
    desc: "you can change your personal information",
    url: ""
}, {
    menuKey: 6,
    id: '6',
    label: "Cutomize Dashboard",
    desc: "you can change your personal information",
    url: ""
}, {
    menuKey: 7,
    id: '7',
    label: "Customize Help Function",
    desc: "you can change your personal information",
    url: "",
}, {
    menuKey: 8,
    id: '8',
    label: "Logout",
    desc: "you can change your personal information",
    url: ""
}];